/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchFacetsState = {
    /**
     * Set expanded state for facets
     * used in facets-items.phtml
     *
     * @param {string} attribute
     * @param {boolean} expanded
     * @returns {boolean}
     */
    setExpandedState(attribute, expanded) {
        if (this.isMobile) {
            return expanded || this.getActiveFacetsCount(attribute) > 0;
        }
        return Boolean(expanded);
    },
    /**
     * Check if facet is visible
     *
     * @param {object} facet
     * @returns {boolean}
     */
    setVisibleState(facet) {

        if (this.shouldHideFacet(facet)) {
            return false;
        }
        const { options, attribute } = facet;
        if (attribute === this.facetConfig.mergedBhAttribute) {
            return options.some(option => option.options.some(subOption => !subOption.disabled));
        }
        return options.some(option => !option.disabled);
    },
    /**
     * Check if facet is active
     *
     * @param {string} attribute
     * @param {string} label
     * @returns {boolean}
     */
    facetIsActive(attribute, label) {
        return this.selectedFacets.some(
            selectedFacet => selectedFacet.attribute === attribute && selectedFacet.option === label
        );
    }
}

export default liveSearchFacetsState;
